module.exports = __webpack_public_path__ + "static/media/Titre4.3214233a.png";